import { useState } from 'react'

interface DemoFloatingIndicatorProps {
  className?: string
}

export function DemoFloatingIndicator({ className = '' }: DemoFloatingIndicatorProps) {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div className={`fixed bottom-6 right-6 z-50 ${className}`}>
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-2 w-64 p-3 bg-background border border-border rounded-lg shadow-lg text-sm text-foreground/80 leading-relaxed">
          <div className="font-medium text-foreground mb-1">Version démo</div>
          <div>
            Vous explorez une version de démonstration de notre plateforme. Les données étant simulées, il peut y avoir
            des incohérences.
          </div>
          {/* Tooltip arrow */}
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-border"></div>
        </div>
      )}

      <div
        className="
          bg-demo-background backdrop-blur-sm
          border border-demo-border
          text-demo-foreground/70
          px-3 py-2
          rounded-full
          text-sm font-normal
          shadow-lg shadow-black/5
          flex items-center gap-2
          hover:bg-demo-background
          transition-all duration-200
          animate-demo-reminder
          cursor-help
        "
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Demo mode indicator - hover for more information"
        role="tooltip"
      >
        <div className="w-2 h-2 bg-amber-500 rounded-full animate-demo-pulse" />
        version démo
      </div>
    </div>
  )
}
